// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file config/config_request.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file config/config_request.proto.
 */
export const file_config_config_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chtjb25maWcvY29uZmlnX3JlcXVlc3QucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IiYKJEdldENhbGVuZGFySW50ZWdyYXRpb25FbmFibGVkUmVxdWVzdCIiCiBHZXRFMmVlSW50ZWdyYXRpb25FbmFibGVkUmVxdWVzdEIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM'
  );

/**
 * @generated from message com.gem.bff.contract.GetCalendarIntegrationEnabledRequest
 */
export type GetCalendarIntegrationEnabledRequest =
  Message<'com.gem.bff.contract.GetCalendarIntegrationEnabledRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetCalendarIntegrationEnabledRequest.
 * Use `create(GetCalendarIntegrationEnabledRequestSchema)` to create a new message.
 */
export const GetCalendarIntegrationEnabledRequestSchema: GenMessage<GetCalendarIntegrationEnabledRequest> =
  /*@__PURE__*/
  messageDesc(file_config_config_request, 0);

/**
 * @generated from message com.gem.bff.contract.GetE2eeIntegrationEnabledRequest
 */
export type GetE2eeIntegrationEnabledRequest =
  Message<'com.gem.bff.contract.GetE2eeIntegrationEnabledRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetE2eeIntegrationEnabledRequest.
 * Use `create(GetE2eeIntegrationEnabledRequestSchema)` to create a new message.
 */
export const GetE2eeIntegrationEnabledRequestSchema: GenMessage<GetE2eeIntegrationEnabledRequest> =
  /*@__PURE__*/
  messageDesc(file_config_config_request, 1);
